//iconMap.ts
import { SvgIconComponent } from "@mui/icons-material";
import PlaylistAddCheckCircleTwoToneIcon from '@mui/icons-material/PlaylistAddCheckCircleTwoTone';
import GroupTwoToneIcon from '@mui/icons-material/GroupTwoTone';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import AssignmentTwoToneIcon from '@mui/icons-material/AssignmentTwoTone';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import BusinessCenterTwoToneIcon from '@mui/icons-material/BusinessCenterTwoTone';
import AccountBalanceTwoToneIcon from '@mui/icons-material/AccountBalanceTwoTone';
import LocalHospitalTwoToneIcon from '@mui/icons-material/LocalHospitalTwoTone';
import SchoolTwoToneIcon from '@mui/icons-material/SchoolTwoTone';
import EventTwoToneIcon from '@mui/icons-material/EventTwoTone';
import AttachMoneyTwoToneIcon from '@mui/icons-material/AttachMoneyTwoTone';
import CardTravelTwoToneIcon from '@mui/icons-material/CardTravelTwoTone';
import TimeToLeaveTwoToneIcon from '@mui/icons-material/TimeToLeaveTwoTone';
import HomeWorkTwoToneIcon from '@mui/icons-material/HomeWorkTwoTone';
import BadgeTwoToneIcon from '@mui/icons-material/BadgeTwoTone';

// icon_nameとMUIアイコンの対応関係
export const iconMap: Record<string, SvgIconComponent> = {
  PlaylistAddCheckCircleTwoToneIcon: PlaylistAddCheckCircleTwoToneIcon,
  GroupTwoToneIcon: GroupTwoToneIcon,
  MoreHorizRoundedIcon: MoreHorizRoundedIcon,
  AssignmentTwoToneIcon: AssignmentTwoToneIcon,
  DescriptionTwoToneIcon: DescriptionTwoToneIcon,
  BusinessCenterTwoToneIcon: BusinessCenterTwoToneIcon,
  AccountBalanceTwoToneIcon: AccountBalanceTwoToneIcon,
  LocalHospitalTwoToneIcon: LocalHospitalTwoToneIcon,
  SchoolTwoToneIcon: SchoolTwoToneIcon,
  EventTwoToneIcon: EventTwoToneIcon,
  AttachMoneyTwoToneIcon: AttachMoneyTwoToneIcon,
  CardTravelTwoToneIcon: CardTravelTwoToneIcon,
  TimeToLeaveTwoToneIcon: TimeToLeaveTwoToneIcon,
  HomeWorkTwoToneIcon: HomeWorkTwoToneIcon,
  BadgeTwoToneIcon: BadgeTwoToneIcon,
};

// UI表示用のiconリストと表示名
export const iconOptions = [
  { name: 'PlaylistAddCheckCircleTwoToneIcon', label: 'チェックリスト' },
  { name: 'GroupTwoToneIcon', label: 'グループ' },
  { name: 'AssignmentTwoToneIcon', label: '課題' },
  { name: 'DescriptionTwoToneIcon', label: '文書' },
  { name: 'BusinessCenterTwoToneIcon', label: 'ビジネス' },
  { name: 'AccountBalanceTwoToneIcon', label: '銀行/会計' },
  { name: 'LocalHospitalTwoToneIcon', label: '医療' },
  { name: 'SchoolTwoToneIcon', label: '教育' },
  { name: 'EventTwoToneIcon', label: 'イベント' },
  { name: 'AttachMoneyTwoToneIcon', label: '経費' },
  { name: 'CardTravelTwoToneIcon', label: '出張' },
  { name: 'TimeToLeaveTwoToneIcon', label: '車両' },
  { name: 'HomeWorkTwoToneIcon', label: '在宅勤務' },
  { name: 'BadgeTwoToneIcon', label: 'バッジ/ID' },
  { name: 'MoreHorizRoundedIcon', label: 'その他' },
];